import { Button as StandaloneButton } from '@/components/Button';
import { CourseCountdownTheme } from '@/components/CourseCountdown/theme';
import { Timer as StandaloneTimer } from '@/components/Timer';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: CourseCountdownTheme });

const Base = $({ as: 'div', slot: 'base' });
const Logo = $({ as: 'picture', slot: 'logo' });
const Description = $({ as: 'p', slot: 'description' });
const Timer = GenericSlot({ as: StandaloneTimer, theme: CourseCountdownTheme.Timer });
const Button = GenericSlot({ as: StandaloneButton, theme: CourseCountdownTheme.Button });

export const CourseCountdown = Object.assign(Base, {
  Logo,
  Description,
  Timer,
  Button,
});
